import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";

import { Icon, List } from "~/components/blocks";

type Props = {
  files: File[];
  onClick: (file: File) => void;
};

const Root = styled(List)(() =>
  css({
    border: "none",
  }),
);

const Item = styled(List.Item)(({ theme }) =>
  css({
    alignItems: "center",
    display: "flex",
    borderRadius: theme.radii.default,
    border: theme.borders.default,
    justifyContent: "space-between",
    padding: `calc(${theme.space.m} + ${theme.space.s})`,
    wordBreak: "break-all",
    "&:hover": {
      boxShadow: theme.shadows.default,
      cursor: "pointer",
    },
    "& + &": {
      marginTop: theme.space.m,
    },
  }),
);

export const FileList = React.memo((props: Props) => {
  return (
    <Root>
      {props.files.map((file, idx) => (
        <Item key={idx} onClick={() => props.onClick(file)}>
          {file.name}
          <Icon color="lightGrey" icon="arrow-right" size="l" />
        </Item>
      ))}
    </Root>
  );
});

FileList.displayName = "FileList";
